import React from 'react'
import { useRouter } from 'next/router'

import { SectionResponse } from 'services/apiTypes/comment.types'

import { PAGE_SIZE } from 'types/comments'

import SortingDropdown from 'components/forumPage/SortingDropdown'
import ThreadListItem from 'components/forumPage/ThreadListItem'
import Paginator from 'components/elements/Paginator'

import styles from './listOfThreads.module.scss'

type Props = { category: string; section: string; threads: SectionResponse }

const ListOfThreads = ({ category, section, threads }: Props) => {
  const router = useRouter()

  const page = `${router.query.page || 1}`
  const orderBy = `${router.query.orderBy || '-updatedAt'}`
  const q = `${router.query.q || ''}`

  const totalPages = Math.ceil((threads?.count || 0) / PAGE_SIZE.THREADS) || 1

  const PageChanger = ({ bottomOfPage }: { bottomOfPage?: boolean }) => (
    <Paginator
      activePage={Number(page) || 1}
      totalPages={totalPages}
      urlBeforePageNumber={`/forum/${category}/${section}?q=${q}&orderBy=${orderBy}&page=`}
      className={bottomOfPage ? styles.paginator : undefined}
    />
  )

  return (
    <>
      <header className={styles.header}>
        <PageChanger />
        <SortingDropdown />
      </header>

      <div className={styles.list}>
        {threads?.results.map((thread, index) => <ThreadListItem thread={thread} key={index} />)}
      </div>

      <PageChanger bottomOfPage />
    </>
  )
}

export default ListOfThreads
